import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Template, TemplateInput } from '@telega/shared';
import { request } from './client';

export const templateKey = ['template'] as const;

export function useTemplate() {
  return useQuery({ queryKey: templateKey, queryFn: () => request<Template>('/template') });
}

export function useSaveTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: TemplateInput) => request<Template>('/template', { method: 'PUT', body }),
    onSuccess: (saved) => qc.setQueryData(templateKey, saved),
  });
}
